<template>
  <div class="mr-0 bg-gray-200 maincomponent-area">
    <div class="px-5 py-3">
      <router-link to="/clients" class="text-sm text-gray-700 hove:text-gray-900">
        Hem / Klienter
      </router-link>
      <h1 class="mt-3 font-sans text-xl leading-none font-medium text-gray-900 whitespace-no-wrap">
        {{ current.clientId }}
      </h1>
    </div>
    <div class="mx-auto">
      <div class="flex items-justify bg-white">
        <tabs class="relative w-full" v-if="current.clientId !== undefined">
          <tab name="allmänt" :selected="true">
            <clientgeneral />
          </tab>
          <tab name="resurser" :selected="false">
            <clientresources />
          </tab>
          <tab name="secrets" :selected="false">
            <clientsecrets />
          </tab>
          <tab name="grant types" :selected="false">
            <clientgranttypes />
          </tab>
          <tab name="urls" :selected="false">
            <clienturls />
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Tabs from "@/components/Tabs";
import Tab from "@/components/Tab";
import ClientGeneral from "./ClientGeneral";
import ClientResources from "./ClientResources";
import ClientUrls from "./ClientUrls";
import ClientSecrets from "./ClientSecrets";
import ClientGrantTypes from "./ClientGrantTypes";

export default {
  name: "clientdetails",
  components: {
    clientgeneral: ClientGeneral,
    clientresources: ClientResources,
    clienturls: ClientUrls,
    clientsecrets: ClientSecrets,
    clientgranttypes: ClientGrantTypes,
    tabs: Tabs,
    tab: Tab
  },
  computed: {
    ...mapGetters("clientsStore", ["current"])
  },
  methods: {
    ...mapActions("clientsStore", ["fetch"])
  },

  async mounted() {
    await this.fetch(this.$route.params.id);
  }
};
</script>
